exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* stylelint-disable */\n\n/* ==========================================================================\n   Notice\n   ========================================================================== */\n.notice {\n  display: flex;\n  padding: 15px 20px;\n  position: relative;\n  border-radius: 3px;\n  color: #666;\n  text-align: start; }\n  .notice .notice__title {\n    padding-top: 0; }\n  .notice .notice__close-icon {\n    color: currentColor; }\n\n.notice__icon {\n  margin-right: 15px; }\n\n.notice__content {\n  flex: 1 1 0;\n  max-width: 767px;\n  padding: 5px 10px 5px 5px; }\n\n.notice__close-icon {\n  position: absolute;\n  top: 15px;\n  right: 20px; }\n\n/* Background Colors\n   ========================================================================== */\n.notice--background-white {\n  background-color: #fff; }\n\n.notice--background-light {\n  background-color: #f2f2f2; }\n\n/* Borders and Shadows\n   ========================================================================== */\n.notice--border {\n  border-left: 3px solid transparent; }\n\n.notice--shadow {\n  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 5px 0 rgba(0, 0, 0, 0.16); }\n\n/* Types\n   ========================================================================== */\n.notice--type-success {\n  border-color: #6acb4c; }\n  .notice--type-success .list__icon {\n    color: #6acb4c; }\n\n.notice--type-error {\n  border-color: #f54545; }\n  .notice--type-error .list__icon {\n    color: #f54545; }\n\n.notice--type-warning {\n  border-color: #eca03e; }\n  .notice--type-warning .list__icon {\n    color: #eca03e; }\n\n.notice--type-instruction {\n  border-color: #25b8d2; }\n  .notice--type-instruction .list__icon {\n    color: #25b8d2; }\n\n.notice--type-info {\n  border-color: #834ba2; }\n  .notice--type-info .list__icon {\n    color: #834ba2; }\n\n.notice--type-hint {\n  border-color: #c2c2c2; }\n  .notice--type-hint .notice__title {\n    color: #c2c2c2; }\n\n@media (max-width: 767px) {\n  .notice {\n    padding: 10px; }\n    .notice .notice__icon {\n      max-width: 20px;\n      max-height: 20px;\n      margin-right: 5px; }\n  .notice__title {\n    padding-bottom: 0; }\n  .notice__content {\n    padding: 10px 5px; }\n  .notice__icon-wrapper {\n    padding-top: 10px; }\n  .notice--border {\n    border-width: 2px; } }\n", ""]);

// exports
exports.locals = {
	"color-groups": "base | colors | primary | semantic | chart",
	"colors-white": "#fff",
	"colors-red": "#f54545",
	"colors-green": "#6acb4c",
	"colors-body-color": "#363636",
	"colors-grey-90": "#444",
	"colors-grey-80": "#666",
	"colors-grey-70": "#858484",
	"colors-grey-60": "#a4a4a4",
	"colors-grey-50": "#c2c2c2",
	"colors-grey-40": "#ddd",
	"colors-grey-30": "#ececec",
	"colors-grey-20": "#f2f2f2",
	"colors-grey-10": "#f8f8f8",
	"colors-black": "#000",
	"base-brown-100": "#343230",
	"base-brown-80": "#474340",
	"base-brown-60": "#61554c",
	"base-brown-40": "#998673",
	"base-brown-20": "#c1aa95",
	"base-earth-100": "#bbb6af",
	"base-earth-80": "#c7c1b8",
	"base-earth-60": "#d7cebf",
	"base-earth-40": "#eae4db",
	"base-earth-20": "#e9e7db",
	"base-earth-10": "#f7f5eb",
	"primary-romantic-purple-base": "#834ba2",
	"primary-romantic-purple-dark": "#5a3770",
	"primary-romantic-purple-light": "#ab83c4",
	"primary-sky-blue-base": "#25b8d2",
	"primary-sky-blue-dark": "#1797ae",
	"primary-sky-blue-light": "#57d0dd",
	"primary-mint-base": "#3fc798",
	"primary-mint-dark": "#2cab7f",
	"primary-mint-light": "#79dbb5",
	"primary-grassy-base": "#96cb4c",
	"primary-grassy-dark": "#81a03c",
	"primary-grassy-light": "#b7dd7a",
	"primary-desert-sunset-base": "#eca03e",
	"primary-desert-sunset-dark": "#c2802a",
	"primary-desert-sunset-light": "#fbc75c",
	"primary-salmon-base": "#f57b45",
	"primary-salmon-dark": "#d45e2a",
	"primary-salmon-light": "#ef9a78",
	"semantic-color-primary": "#f57b45",
	"semantic-color-primary-hovered": "#d45e2a",
	"semantic-color-primary-active": "#ef9a78",
	"semantic-color-secondary": "#25b8d2",
	"semantic-color-secondary-hovered": "#1797ae",
	"semantic-color-secondary-active": "#57d0dd",
	"semantic-color-light": "#fff",
	"semantic-color-light-hovered": "#fff",
	"semantic-color-light-active": "#fff",
	"semantic-color-dark": "#f8f8f8",
	"semantic-color-dark-hovered": "#f2f2f2",
	"semantic-color-dark-active": "#f8f8f8",
	"semantic-color-error": "#f54545",
	"semantic-color-success": "#6acb4c",
	"semantic-color-warning": "#eca03e",
	"semantic-color-instruction": "#25b8d2",
	"semantic-color-info": "#834ba2",
	"semantic-color-hint": "#c2c2c2",
	"chart-first": "#25b8d2",
	"chart-second": "#f57b45",
	"chart-third": "#96cb4c",
	"chart-fourth": "#eca03e",
	"chart-fifth": "#3fc798",
	"chart-sixth": "#ab83c4",
	"chart-seventh": "#c1aa95",
	"chart-eighth": "#c2c2c2"
};